import { useLocale } from 'src/providers/LocaleProvider';
import { ButtonType, GreenButton } from '../buttons/greenButton';
import { useStyles } from './styles';
import useChangeTheme from 'src/hooks/useChangeTheme';
import { getButtonColor } from 'src/helpers';
import { observer } from 'mobx-react';

export const UnhandledExceptionNotification = observer(() => {
    const styles = useStyles();
    const {
        common: { unhandledException, reloadPage },
    } = useLocale();

    const appearanceTheme = useChangeTheme();

    return (
        <div className={styles.notificationContainer}>
            <p className={styles.notificationText}>
                {unhandledException(
                    'Oops! An unexpected error has occurred. Our team has been notified and is diligently working to resolve the issue. Feel free to refresh the page or try again. We apologize for any inconvenience caused.'
                )}
            </p>
            <GreenButton
                text={reloadPage('Reload page')}
                isWidthFixed
                type={getButtonColor(appearanceTheme, ButtonType)}
                onClick={() => {
                    window.location.reload();
                }}
            />
        </div>
    );
});
